export const userRoles = {
  SUPER_ADMIN: 'super-admin',
  COMPANY_ADMIN: 'company-admin',
  DEPARTMENT_ADMIN: 'department-admin',
  EMPLOYEE: 'customer',
  CANDIDATE: 'candidate',
  RESELLER: 'reseller',
};
